// react-table v7 fills row props and cells only after prepareRow runs
// in the same render that draws the row. This helper keeps that contract
// without treating the table method as a parent callback.
export function prepareReactTableRow(prepareRow, row) {
	prepareRow(row)
	return row
}
